import { defineMessages } from "react-intl";

export default defineMessages({
  supportLink: {
    id: "Nsk5WL",
    defaultMessage: "Get support",
    description: "link",
  },
  aboutAppTitle: {
    id: "6jyoEd",
    defaultMessage: "About this extension",
    description: "section header",
  },
  appPermissionsTitle: {
    id: "uIYU0D",
    defaultMessage: "Extension permissions",
    description: "section header",
  },
  appNoPermissions: {
    defaultMessage: "App doesn't have any permissions granted.",
    id: "wDYozn",
  },
  appPermissionsDescription: {
    id: "750Ymk",
    defaultMessage: "This extension has permissions to:",
    description: "apps about permissions",
  },
  dataPrivacyTitle: {
    id: "a55zOn",
    defaultMessage: "Data privacy",
    description: "section header",
  },
  dataPrivacyDescription: {
    id: "Q69IGA",
    defaultMessage: "View this extension’s privacy policy.",
    description: "extension privacy policy link",
  },
  noDataPrivacyPage: {
    id: "NUBTlN",
    defaultMessage: "Extension doesn't provide a privacy policy.",
  },
  noAboutApp: {
    id: "kbezTI",
    defaultMessage: "Extension doesn't provide a description.",
  },
  editPermissionsButton: {
    defaultMessage: "Edit permissions",
    id: "psmnv9",
  },
});
